import HeaderCardF1 from './headerCardF1/headerCardF1';
import BodyCardF1 from './bodyCardF1/bodyCardF1';
import FooterCardF1 from './footerCardF1/footerCardF1';
import { getSponsorClass } from '../../../../functions/functions';
import './cardF1.sass';

/**
 * Componente que representa una tarjeta de evento de Fórmula 1.
 * Muestra el encabezado, cuerpo (con datos del evento) y pie si aplica.
 * Se renderiza como un `<a>` para redirigir al evento externo (`opta_event_url`).
 */
export default function CardFormula1({ data, flagMomios, patrocinador, indexJson }) {
  // Verifica si la tarjeta tiene una clase válida para mostrar el footer
  const isValidClass = !['clarosports-finished-game', 'clarosports-error-game'].includes(data.class);
  // Determina si se deben mostrar momios
  const showFooter = (flagMomios === true || flagMomios === 'true') && isValidClass;

  return (
    <a className={`carrousel-card-sponsored card-f1 ${getSponsorClass(patrocinador)}`} href={data.opta_event_url} target="_parent" rel="noreferrer">
      {/* Encabezado del card (fecha, torneo, lugar, etc.) */}
      <HeaderCardF1 data={data} indexJson={indexJson} />

      {/* Cuerpo principal del partido (jugadores, marcador, sets, etc.) */}
      <BodyCardF1 data={data} flagMomios={flagMomios} patrocinador={patrocinador} />

      {/* Pie de tarjeta solo si aplica mostrar momios */}
      {showFooter
        ? <FooterCardF1 data={data} patrocinador={patrocinador} />
        : <div className='card-f1__footer_empty'></div>
      }
    </a>
  )
}